export default {"src":"/_next/static/media/highlight-item.9178a010.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};